
import { Vue, Options } from "vue-class-component";
import { Prop, Emit, Watch } from "vue-property-decorator";
import TableActionButton from "../atoms/TableActionButton.vue";
import Avatar from "../atoms/Avatar.vue";
import { VueEternalLoading, LoadAction } from "@ts-pro/vue-eternal-loading";

@Options({
  components: { TableActionButton, Avatar, VueEternalLoading }
})
export default class Table extends Vue {
  @Prop({ type: Array, required: true }) header?: {
    type: "button" | "text" | "selection";
    sortable?: boolean;
    title?: string;
    key: string;
    width?: ("shrink" | "expand") | number;
    color?: string;
    disabled: Function;
  }[];
  @Prop({ type: Array }) tableData?: object[];
  displayData: { [key: string]: any }[] = [];
  @Prop({ type: Boolean }) rowEnhance = false;
  pageSize = 100;
  isInitial = false;
  @Prop({ type: Function }) callback?: Function;
  sortKey: string = "";
  sortOrders: { [key: string]: number } = {};
  lastSortedKey: string = "";
  @Prop({ type: Function }) allSelectionCallback?: Function;

  mounted() {
    if (this.header) {
      this.header.forEach(head => {
        if (head.key) this.sortOrders[head.key] = 1;
        if (!head.type) head.type = "text";
      });
    }
  }

  get filteredDisplayDatas() {
    let sortKey = this.sortKey;
    let order = this.sortOrders[sortKey] || 1;
    let displayData = this.displayData;
    if (sortKey && displayData) {
      displayData = displayData.slice().sort((a, b) => {
        a = a[sortKey];
        b = b[sortKey];
        return (a === b ? 0 : a > b ? 1 : -1) * order;
      });
    }
    return displayData;
  }

  @Emit("column-click")
  onColumnClick(index: number, key: string, event: Event) {
    const rowData = this.displayData[index];
    return { row: index, col: key, el: event && event.target, rowData };
  }
  @Emit("selection-change")
  onSelectionChange(event: Event, index: number) {
    const target = event.target as HTMLInputElement;
    return { index, value: target.checked };
  }
  @Watch("tableData")
  reset() {
    this.displayData = [];
    this.isInitial = true;
  }
  sortBy(key: string, type: string) {
    if (type !== "text") return;
    this.sortKey = key;
    this.sortOrders[key] = this.sortOrders[key] * -1;
    this.lastSortedKey = key;
  }
  /**
   * テーブル更新  updatedAtの降順でソートを行う
   * @param {LoadAction} action VueEternalLoadingのトリガーアクション
   * @return void
   */
  async load(action: LoadAction): Promise<any> {
    if (this.callback) {
      await this.callback()
        .then((loadedData: any) => {
          if (loadedData.length) {
            if (loadedData[0].updatedAt) {
              loadedData.sort(function(a: any, b: any) {
                if (a.updatedAt !== b.updatedAt) {
                  return a.updatedAt < b.updatedAt ? 1 : -1;
                }
                return 0;
              });
              loadedData = loadedData.map((d: any, index: number) => ({
                orgIndex: this.displayData.length ? index + this.displayData.length : index,
                ...d
              }));
            }
            this.displayData.push(...loadedData);
            action.loaded(loadedData.length);
          } else {
            action.noMore();
          }
        })
        .catch(() => {
          action.noMore();
        });
    } else {
      if (!this.tableData) return;
      let loadedData = this.tableData.slice(this.displayData.length, this.displayData.length + this.pageSize);
      if (loadedData.length) {
        const _sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
        await _sleep(350);
        loadedData = loadedData.map((d: any, index: number) => ({
          orgIndex: this.displayData.length ? index + this.displayData.length : index,
          ...d
        }));
        this.displayData.push(...loadedData);
        action.loaded(this.displayData.length, this.pageSize);
      } else {
        action.noMore();
      }
    }
  }
  onSelectionAll(key: string, event: Event) {
    const target = event.target as HTMLInputElement;
    if (this.allSelectionCallback) {
      this.allSelectionCallback(this.displayData, target.checked);
    } else {
      this.displayData.forEach(data => {
        data[key] = target.checked;
      });
    }
    this.$emit("selection-all-change", event);
  }
}
